import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
// 引入语言配置文件
import cn from './config/cn.js'
import en from './config/english.js'
import vt from './config/vi.js'
import ind from './config/id.js'
import my from './config/malay.js'
import th from './config/thai.js'
import tr from './config/tr.js'
import zh_cn from './config/zh_cn.js'
import ch from './config/ch.js'
// 创建实例
const i18n = new VueI18n({
    locale:localStorage.getItem("language")?JSON.parse(localStorage.getItem("language")).value:false || 'pt',
    messages:{
        'cn':cn,
        "en":en,
        "ch":ch,
        'pt':zh_cn,
        'vi':vt,
        'id':ind,
        'th':th,
        'tr':tr,
        'msa':my
    }
})
// 暴露并在man.js引入
export default i18n



// WEBPACK FOOTER //
// ./src/utils/lang/index.js